/* @ngInject */
const myNewUserForm = (
  toaster,
  userService,
  valueHandler,
  $$account
) => {
  return {
    restrict: 'E',
    scope: {

    },
    template: require('./myNewUserForm.html'),
    /* @ngInject */
    controller: (
      $scope
    ) => {
      $scope.fieldsOptions = $$account.metadata.fields

      $scope.createUser = (_username, _password, _admin) => {
        if (valueHandler.isEmpty($scope.admin)) {
          $scope.admin = false
        }

        userService.register(_username, _password, _admin)
          .then((message) => {
            toaster.message(message)

            $scope.username = null
            $scope.password = null
            $scope.admin = null
            $scope.newForm.$setPristine()
            $scope.newForm.$setUntouched()
          }, (error) => {
            toaster.error(error)
          })
      }
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}
export default myNewUserForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/account/directives/myNewUserForm.js